"use client";

import { useEffect, useState } from "react";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { MenuItemWithSvg } from "./MenuItemWithSvg";

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // 监听 HomeClient 中的滚动容器
      const scrollContainer = document.querySelector("[data-scroll-ref]");
      const scrollTop = scrollContainer
        ? scrollContainer.scrollTop
        : window.scrollY;

      // 当滚动超过第一屏时，改变背景色
      setIsScrolled(scrollTop > 500);
    };

    // 立即执行一次以获取初始状态
    handleScroll();

    // 监听 HomeClient 中的滚动容器
    const scrollRef = document.querySelector("[data-scroll-ref]");
    if (scrollRef) {
      scrollRef.addEventListener("scroll", handleScroll);
    } else {
    }

    return () => {
      if (scrollRef) {
        scrollRef.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  return (
    <div
      className="h-[4em]  z-[20] fixed w-[100%] pr-[var(--scrollbar-width)]  flex   "
      style={{
        scrollbarGutter: "stable",
      }}
    >
      <div
        className={`w-[100%] flex  px-[50px] h-[4em]  items-center  justify-center shadow-[0_2px_5px_rgba(45,79,126,0.3)] ${isScrolled ? "bg-white" : "bg-white/30"
          }  outline-offset-[-1px] outline-white backdrop-blur-[5px] `}
      >
        <img src="/imgs/logo-header.png" className="w-[180px] h-[40px]" />

        <div className="flex-1 pl-[160px] flex items-center gap-[40px]">
          <a href="/" className="w-[110px]  text-center">
            <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-regular text-[18px] text-black">
              首页
            </div>
          </a>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-regular text-[18px] text-black flex items-center gap-[5px] group hover:text-[#1677FF]">
                产品服务
                <svg
                  width="25"
                  height="25"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M27 13.5L18 22.5L9 13.5"
                    stroke="#000"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="group-hover:stroke-[#1677FF]"
                  />
                </svg>
              </div>
            </DropdownMenuTrigger>
            <DropdownMenuContent
              className=" px-[20px] py-[20px] flex-col gap-[20px] relative top-[20px]"
              align="start"
            >
              <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[18px] text-[#777777] flex items-center gap-[5px] ">
                SD-WAN组网
              </div>
              <MenuItemWithSvg
                svgFileName="Frame-18.svg"
                title="全球SD-WAN网络加速服务"
                link="/sdwan"
              />
              <MenuItemWithSvg
                svgFileName="Frame-17.svg"
                title="企业组网"
                link="/kwan"
              />
              <MenuItemWithSvg
                svgFileName="Frame-17.svg"
                title="企业异地组网私有化部署"
                link="/private"
              />
              <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[18px] text-[#777777]">
                企业出海网络服务
              </div>
              <MenuItemWithSvg
                svgFileName="Frame-16.svg"
                title="光年全球直播专线"
                link="/liveStreaming"
              />
              <MenuItemWithSvg
                svgFileName="Frame-15.svg"
                title="TK直播/养号专线"
                link="/tiktok"
              />
              <MenuItemWithSvg
                svgFileName="Frame-14.svg"
                title="全球办公网络与应用加速"
                link="/saas"
              />
            </DropdownMenuContent>
          </DropdownMenu>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <div className=" font-regular text-[18px] text-black flex items-center gap-[5px] group hover:text-[#1677FF]">
                解决方案
                <svg
                  width="25"
                  height="25"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M27 13.5L18 22.5L9 13.5"
                    stroke="#000"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="group-hover:stroke-[#1677FF]"
                  />
                </svg>
              </div>
            </DropdownMenuTrigger>
            <DropdownMenuContent
              className=" px-[30px] py-[20px] flex-col gap-[20px] relative top-[20px]"
              align="start"
            >
              <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[18px] text-[#777777]">
                SD-WAN解决方案
              </div>
              <div className="flex justify-between gap-[20px]">
                <MenuItemWithSvg
                  svgFileName="Frame-4.svg"
                  title="远程办公"
                  link="/solutions#remote-office"
                />
                <MenuItemWithSvg
                  svgFileName="Frame-12.svg"
                  title="智慧安防"
                  link="/solutions#smart-security"
                />
              </div>
              <div className="flex justify-between gap-[20px]">
                <MenuItemWithSvg
                  svgFileName="Frame-6.svg"
                  title="IT互联网"
                  link="/solutions#it-internet"
                />
                <MenuItemWithSvg
                  svgFileName="Frame-11.svg"
                  title="智能交通"
                  link="/solutions#smart-traffic"
                />
              </div>
              <div className="flex justify-between gap-[20px]">
                <MenuItemWithSvg
                  svgFileName="Frame-7.svg"
                  title="智慧医疗"
                  link="/solutions#smart-medical"
                />
                <MenuItemWithSvg
                  svgFileName="Frame-10.svg"
                  title="零售连锁"
                  link="/solutions#retail-chain"
                />
              </div>
              <div className="flex justify-between gap-[20px]">
                <MenuItemWithSvg
                  svgFileName="Frame-8.svg"
                  title="智能酒店"
                  link="/solutions#smart-hotel"
                />
                <MenuItemWithSvg
                  svgFileName="Frame-9.svg"
                  title="智慧教育"
                  link="/solutions#smart-education"
                />
              </div>
              <div className="flex justify-between gap-[20px]">
                <MenuItemWithSvg
                  svgFileName="Frame-5.svg"
                  title="智能制造"
                  link="/solutions#smart-manufacture"
                />
              </div>
            </DropdownMenuContent>
          </DropdownMenu>
          {/* <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[20px] text-black flex items-center gap-[5px] group hover:text-[#0182FF]">
                资源中心
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M27 13.5L18 22.5L9 13.5"
                    stroke="#000"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="group-hover:stroke-[#0182FF]"
                  />
                </svg>
              </div>
            </DropdownMenuTrigger>
            <DropdownMenuContent
              className="w-[200px] min-w-[200px] px-[20px] py-[20px] flex-col gap-[20px] relative top-[15px]"
              align="start"
            >
              <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[18px] text-[#777777]">
                帮助中心
              </div>
              <MenuItemWithSvg svgFileName="Frame-3.svg" title="常见问题" />
              <MenuItemWithSvg svgFileName="Frame-2.svg" title="产品使用教程" />
              <MenuItemWithSvg svgFileName="Frame-2.svg" title="出海教程" />
              <div className="font-[Alibaba PuHuiTi 3.0,Alibaba PuHuiTi 30] font-normal text-[18px] text-[#777777]">
                新闻中心
              </div>
              <MenuItemWithSvg svgFileName="Frame-1.svg" title="企业动态" />
              <MenuItemWithSvg svgFileName="Frame.svg" title="出海咨询" />
            </DropdownMenuContent>
          </DropdownMenu> */}
        </div>

        <a
          href="https://t22qshgkpd.jiandaoyun.com/f/68cb68e880eabb692970b84a"
          target="_blank"
          rel="noopener noreferrer"
          className="flex w-[80px] h-[30px] justify-center items-center gap-[0.625rem] rounded-[0.625rem] bg-gradient-to-r from-[#5AB9FF] to-[#C099FF] cursor-pointer"
        >
          <div className="text-white font-['Alibaba_PuHuiTi_3.0'] text-[12px] font-bold leading-none">
            联系我们
          </div>
        </a>
      </div>
    </div>
  );
};
